import { render, staticRenderFns } from "./WiringsList.vue?vue&type=template&id=16b4a0df&scoped=true"
import script from "./WiringsList.vue?vue&type=script&lang=js"
export * from "./WiringsList.vue?vue&type=script&lang=js"
import style0 from "./WiringsList.vue?vue&type=style&index=0&id=16b4a0df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b4a0df",
  null
  
)

export default component.exports